var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderBgr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1478,
    height: 200,
    viewBox: "0 0 1478 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k1yow5o7ma",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "54.36%",
    y2: "51.695%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zuvvsz3ctb",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "55.655%",
    y2: "52.198%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0yxlk01yoc",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "55.508%",
    y2: "52.141%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ti9zsl1ufd",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "54.689%",
    y2: "51.823%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lbws4kudze",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "54.875%",
    y2: "51.895%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4g6nf05kzf",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "55.569%",
    y2: "52.165%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qql22vqokg",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "56.602%",
    y2: "52.566%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7zae22pdph",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "66.034%",
    y2: "56.232%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ppadrahkki",
    x1: "75.25%",
    x2: "-49.917%",
    y1: "62.423%",
    y2: "54.829%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203184"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k1yow5o7ma)",
    d: "M288.128 52.479L393.1 11.75 426.057 38.742z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(-0.000000, 40.134919)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zuvvsz3ctb)",
    d: "M78.324 54.629L133.753 40.793 200.267 65.814 111.251 81.805z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(-0.000000, 40.134919)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M133.753 40.793L149.504 18.279 200.284 30.847 200.267 65.814z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(-0.000000, 40.134919)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0yxlk01yoc)",
    d: "M149.674 18.337L240.648 6.486 288.247 52.479z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(-0.000000, 40.134919)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M259.353 24.833L329.227 0 393.072 11.76 288.128 52.479zM6.805 34.419L91.885 19.341 134.294 40.929 0 74.301z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(-0.000000, 40.134919)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ti9zsl1ufd)",
    d: "M393.072 79.084L529.768 27.25 562.335 54.44z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(477.703910, 53.167293) scale(-1, -1) translate(-477.703910, -53.167293)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M759.601 67.943L716.543 59.585 815.207 21.433 864.178 50.44z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(790.360472, 44.687813) scale(-1, -1) translate(-790.360472, -44.687813)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lbws4kudze)",
    d: "M649.777 9.751L708.571 0 775.807 39.354 684.662 32.56z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(712.792212, 19.677065) scale(-1, -1) translate(-712.792212, -19.677065)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M631.211 22.304L647.08 0 717.013 17.288 698.447 61.658z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(674.111961, 30.829041) scale(-1, -1) translate(-674.111961, -30.829041)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4g6nf05kzf)",
    d: "M562.335 39.167L653.42 27.25 701.144 73.575z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(631.739555, 50.412464) scale(-1, -1) translate(-631.739555, -50.412464)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M460.223 52.031L529.726 27.25 591.169 41.297 489.057 79.952z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(435.758501, 101.051906) scale(1, -1) rotate(5.000000) translate(-435.758501, -101.051906) translate(3.669632, 40.082191) translate(525.696230, 53.601156) scale(-1, -1) translate(-525.696230, -53.601156)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#qql22vqokg)",
    d: "M0 106.954L103.921 66.272 111.953 106.341z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#7zae22pdph)",
    d: "M103.921 93.05L166.837 66.272 174.633 106.314z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(139.276689, 86.293157) scale(-1, -1) translate(-139.276689, -86.293157)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M481.285 0L584.446 4.591 643.638 52.785 498.503 93.872z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(562.461510, 46.936094) scale(-1, -1) translate(-562.461510, -46.936094)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ppadrahkki)",
    d: "M361.65 0.144L472.31 34.327 540.477 75.086 468.177 89.282z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(451.063294, 44.712958) scale(-1, -1) translate(-451.063294, -44.712958)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M361.423 35.239L378.223 14.34 429.817 27.102 429.59 75.998z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(395.619754, 45.168902) scale(-1, -1) translate(-395.619754, -45.168902)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4g6nf05kzf)",
    d: "M274.208 53.507L365.293 41.59 413.016 87.914z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(343.611935, 64.752325) scale(-1, -1) translate(-343.611935, -64.752325)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203184",
    d: "M103.921 66.371L173.423 41.59 303.042 69.61 132.755 94.292z",
    transform: "translate(21.000000, 59.000000) translate(-20.898463, -58.448247) translate(1151.796109, 81.321739) rotate(5.000000) translate(-1151.796109, -81.321739) translate(829.976999, 27.844888) translate(203.481209, 67.941017) scale(-1, -1) translate(-203.481209, -67.941017)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBgr);
export default __webpack_public_path__ + "static/media/header-bgr.59f567cb7682121d5ef98419be547c3d.svg";
export { ForwardRef as ReactComponent };